window.onHeartBeatUpdates = [
  payload => {
    const currentHome = document.body.getAttribute('data-home');
    const language    = document.body.getAttribute('data-language');
    if(currentHome !== payload.home){
      window.location.assign(`/${language}`);
    }

    const currentPageState = document.body.getAttribute('data-page-state');
    if(currentPageState !== payload.state){
      document.querySelectorAll('*[data-page-state]').forEach(el => {
        el.setAttribute('data-page-state', payload.state);
      })
    }

    const trackSession = document.getElementById('track-sessions');
    const currentNowLive = trackSession.getAttribute('data-now-live');
    const itemsUpdatedAt = trackSession.getAttribute('data-items-updated-at');

    const liveMessage = document.getElementById('live-message');
    const nowLive = payload.now[0];
    const nowItemsUpdatedAt = payload.items_updated_at.toString();

    if(itemsUpdatedAt !== nowItemsUpdatedAt){
      fetch(`/${language}/tracks.json?r=${Math.random()}`).then(res => res.json()).then(data => {
        trackSession.innerHTML = data.payload.view;
        trackSession.setAttribute('data-items-updated-at', nowItemsUpdatedAt);

        trackSession.setAttribute('data-now-live', nowLive);
        const nowSession = trackSession.querySelector('li[data-item="'+nowLive+'"]');
        if(nowSession) {
          nowSession.classList.add('active');
          scrollTrackToActiveItem();
        }
      });
    }

    if(currentNowLive !== nowLive){
      if(!trackSession)return;
      trackSession.setAttribute('data-now-live', nowLive);
      trackSession.querySelectorAll('li').forEach(el=> {
        el.classList.remove('active');
      });

      const nowSession = trackSession.querySelector('li[data-item="'+nowLive+'"]');
      if(nowSession) {
        nowSession.classList.add('active');
        scrollTrackToActiveItem();
      }

      if(!liveMessage)return;
      liveMessage.setAttribute('data-now-live', nowLive);

      if(nowLive < 0) return;
      document.getElementById('live-name').innerHTML = nowSession.querySelector('.track-session-name').innerHTML;
      document.getElementById('live-body').innerHTML = nowSession.querySelector('.track-session-body').innerHTML;
      document.getElementById('live-detail').innerHTML = nowSession.querySelector('.track-session-detail').innerHTML
    }
  }
]

function scrollTrackToActiveItem(){
  const track = document.getElementById('track-sessions');
  if(!track)return;
  const activeItem = track.querySelector('li[class="active"]');
  if(activeItem){
    track.scrollTop = activeItem.offsetTop;
  }
}

function syncVideoTrackHeight(){
  const elMainContent = document.getElementById('main-content');
  const elTrack = document.getElementById('tracks');
  const elTrackHeader = elTrack?.querySelector('header');
  const elTrackSession = document.getElementById('track-sessions') || document.getElementById('library-tracks');
  const elDownloadBanner = document.getElementById('report-download');
  if(! elTrackSession )return;

  elTrackSession.style.maxHeight = (elMainContent.offsetHeight - (elTrackHeader?.offsetHeight || 0)) - (elDownloadBanner?.offsetHeight || 0) + 'px';
}
window.addEventListener('resize', ()=>{
  syncVideoTrackHeight();
  scrollTrackToActiveItem();
});


function setupNavMenu(){
//open navigation menu
  const menuToggle = document.getElementById('nav-menu-toggle');
//  const menu = document.getElementById('nav-menu');
  const menuClose = document.getElementById('nav-menu-close');

  if(menuToggle){
    const open = () =>{
      document.body.classList.add('modal-open', 'nav-menu-open');
    }

    const close = () => {
      document.body.classList.remove('modal-open', 'nav-menu-open');
      document.body.style.paddingRight = "";
    }

    if(menuClose){
      menuClose.addEventListener('click', ev => {
        ev.preventDefault();
        ev.stopPropagation();
        close();
      })
    }

    menuToggle.addEventListener('click', ev =>{
      ev.preventDefault();
      ev.stopPropagation();
      document.body.classList.contains('nav-menu-open') ? close() : open();
    })
  }
}

(fn => (document.readyState !== 'loading') ? fn() : document.addEventListener('DOMContentLoaded', fn))(()=>{
  setupNavMenu();

  setTimeout(()=>{
    syncVideoTrackHeight();
    scrollTrackToActiveItem();
  }, 100);
});
